"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChildTokens = exports.serialiseBlock = exports.splitForSelection = exports.serialiseElements = exports.serialise = void 0;
var SideBySide_1 = require("ContentTokens/Models/SideBySide");
var Table_1 = require("ContentTokens/Models/Table");
var ContentLoop_1 = require("ContentTokens/Models/ContentLoop");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var lodash_1 = require("lodash");
var slate_1 = require("slate");
var Utils_1 = require("../Utils");
var Common_1 = require("ContentTokens/Models/Common");
var SerialiseErrorRecorder_1 = require("./SerialiseErrorRecorder");
var DebugEditorState_1 = require("../DebugEditorState");
var MediaVariable_1 = require("ContentTokens/DataModels/MediaVariable");
var MediaVariable_2 = require("ContentTokens/Models/MediaVariable");
var Types_1 = require("@CommonFrontend/ContentTokens/Models/inputs/Types");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var serialise = function (nodes, selection, withSelection) {
    var value = nodes;
    var processedValue = value;
    var temporarySelection = selection;
    if (withSelection && selection) {
        var selectData = (0, exports.splitForSelection)(value, selection);
        temporarySelection = selectData.selection;
        processedValue = selectData.value;
    }
    var commentTracker = {
        currIds: {},
        prevIds: {},
    };
    var editor = (0, Utils_1.createConfiguredEditor)();
    editor.children = processedValue;
    editor.selection = temporarySelection || null;
    var tokens = (0, exports.serialiseElements)(processedValue, editor, commentTracker, temporarySelection);
    return mergeText(tokens);
};
exports.serialise = serialise;
var serialiseElements = function (node, editor, commentTracker, selection) {
    var tokens = [];
    for (var i = 0; i < node.length; i++) {
        var child = node[i];
        var processedTokens = (0, exports.serialiseBlock)(child, editor, commentTracker, selection);
        tokens = tokens.concat(processedTokens);
    }
    if (commentTracker) {
        Object.keys(commentTracker.currIds).forEach(function (id) {
            tokens.push(createCommentEndToken(id));
        });
    }
    var previousToken = null;
    var nextToken = null;
    var newTokens = [];
    for (var i = 0; i < tokens.length; i++) {
        nextToken = getNextNonSelectionToken(i, tokens);
        if (tokens[i].subType == "text" && tokens[i].content == "") {
            if (previousToken && previousToken.type != "block") {
                continue;
            }
            else if (nextToken && nextToken.type != "block") {
                continue;
            }
        }
        if (tokens[i].type != "selection") {
            previousToken = tokens[i];
        }
        newTokens.push(tokens[i]);
    }
    return newTokens;
};
exports.serialiseElements = serialiseElements;
var getNextNonSelectionToken = function (index, tokens) {
    index = index + 1;
    while (index < tokens.length) {
        if (tokens[index].type != "selection") {
            return tokens[index];
        }
        index++;
    }
    return undefined;
};
var splitForSelection = function (value, selection) {
    var editor = (0, Utils_1.createConfiguredEditor)();
    editor.children = value;
    editor.selection = selection;
    var anchorPath = editor.selection.anchor.path;
    var anchorOffset = editor.selection.anchor.offset;
    var anchorNode = slate_1.Node.descendant(editor, anchorPath);
    var atEndAnchor = (0, Utils_1.isAtEndOfNode)(editor.selection.anchor, [anchorNode, anchorPath]);
    var atStartAnchor = (0, Utils_1.isAtStartOfNode)(editor.selection.anchor, [anchorNode, anchorPath]);
    if (!atEndAnchor && !atStartAnchor) {
        (0, Utils_1.splitTextNode)(editor, { path: anchorPath, offset: anchorOffset });
    }
    var focusPath = editor.selection.focus.path;
    var focusOffset = editor.selection.focus.offset;
    var focusNode = slate_1.Node.descendant(editor, focusPath);
    var atEndFocus = (0, Utils_1.isAtEndOfNode)(editor.selection.focus, [focusNode, focusPath]);
    var atStartFocus = (0, Utils_1.isAtStartOfNode)(editor.selection.focus, [focusNode, focusPath]);
    if (!atEndFocus && !atStartFocus) {
        (0, Utils_1.splitTextNode)(editor, { path: focusPath, offset: focusOffset });
    }
    return {
        value: editor.children,
        selection: __assign(__assign({}, editor.selection), { anchorAfter: atEndAnchor, focusAfter: atEndFocus }),
    };
};
exports.splitForSelection = splitForSelection;
var serialiseBlock = function (block, editor, commentTracker, selection) {
    var _a;
    var serialisedRegistryContent = (_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(block.type)) === null || _a === void 0 ? void 0 : _a.serialise(block, editor, commentTracker, selection);
    if (serialisedRegistryContent) {
        return serialisedRegistryContent;
    }
    var newToken = {
        type: "block",
        subType: block.type,
    };
    switch (block.type) {
        case Common_1.BlockType.ListItem:
            newToken.level = block.data.level;
            newToken.listType = block.data.listType;
            var startCounter = block.data.startCounter;
            if (startCounter != null) {
                newToken.startCounter = startCounter;
            }
            break;
        case Common_1.BlockType.GoogleMaps:
            return serialiseGoogleMaps(block, editor, commentTracker, selection);
        case Common_1.BlockType.Iframe:
            return serialiseIframe(block, editor, commentTracker, selection);
        case Common_1.BlockType.Image:
            return serialiseImage(block, editor, commentTracker, selection);
        case Common_1.BlockType.Video:
            return serialiseVideo(block, editor, commentTracker, selection);
        case Common_1.BlockType.ROICalculator:
            return serialiseROICalculator(block, editor, commentTracker, selection);
        case Common_1.BlockType.Accordion:
            return serialiseAccordion(newToken, block, editor, commentTracker, selection);
        case Common_1.BlockType.SideBySide:
            return serialiseSideBySide(block, editor, commentTracker, selection);
        case Common_1.BlockType.Table:
            var tableRows = (0, Table_1.getTableRowNodes)(block);
            newToken.rows = tableRows.length;
            newToken.columns = tableRows[0].children.length;
            newToken.columnBorders = block.data.columnBorders;
            newToken.selection = block.data.selection || null;
            newToken.cells = [];
            for (var i = 0; i < tableRows.length; i++) {
                var row = tableRows[i];
                if (row.type === Common_1.BlockType.TableRepeatingRow) {
                    var repeatingRow = {
                        rowIndex: i,
                    };
                    if (row.data.repeatingToken) {
                        repeatingRow.repeatingToken = row.data.repeatingToken;
                    }
                    newToken.repeatingRows = newToken.repeatingRows || [];
                    newToken.repeatingRows.push(repeatingRow);
                }
                var cellTokens = row.children.map(function (cell) {
                    return (0, exports.serialiseElements)(cell.children, editor, commentTracker, selection);
                });
                newToken.cells.push(cellTokens);
            }
            var tableTokens = [newToken];
            if (selection) {
                var anchorNodeEntry = slate_1.Editor.node(editor, selection.anchor.path);
                var focusNodeEntry = slate_1.Editor.node(editor, selection.focus.path);
                var dummyTextNode = (0, Table_1.getTableDummyNode)(block).children[0];
                if (slate_1.Node.matches(dummyTextNode, anchorNodeEntry[0])) {
                    tableTokens.push(createAnchorToken());
                }
                if (slate_1.Node.matches(dummyTextNode, focusNodeEntry[0])) {
                    tableTokens.push(createFocusToken());
                }
            }
            return tableTokens;
        case Common_1.BlockType.Button:
            newToken.href = block.data.href;
            newToken.text = block.data.text;
            newToken.alignment = block.data.alignment;
            break;
        case Common_1.BlockType.ContentLoop:
            newToken.content = (0, exports.serialiseElements)((0, ContentLoop_1.getContentLoopChildren)(block), editor, commentTracker, selection);
            if (!!block.data.variable) {
                newToken.variable = block.data.variable;
            }
            break;
        case Common_1.BlockType.ContentLoopDummy:
        case Common_1.BlockType.SideBySideDummy:
        case Common_1.BlockType.TableDummy:
        case Common_1.BlockType.AccordionDummy:
            throw new Error("Failed to serialise block because block is of a type not to be serialised - ".concat(block.type));
    }
    return [newToken].concat((0, exports.getChildTokens)(block, editor, commentTracker, selection));
};
exports.serialiseBlock = serialiseBlock;
var serialiseChild = function (child, attributes, parentIsVoid, editor, commentTracker, selection) {
    var tokens = [];
    if (slate_1.Element.isElement(child)) {
        if (parentIsVoid) {
            throw new Error("Inline inside a void block");
        }
        switch (child.type) {
            case Common_1.InlineType.Link:
                attributes.href = child.data.href;
                for (var i = 0; i < child.children.length; i++) {
                    tokens = tokens.concat(serialiseChild(child.children[i], attributes, child.isVoid, editor, commentTracker, selection));
                }
                break;
            case Common_1.InlineType.LineBreak:
                tokens.push(createBreakToken());
                if (selection) {
                    if (slate_1.Editor.node(editor, slate_1.Path.parent(selection.anchor.path))[0] === child) {
                        tokens.push(createAnchorToken());
                    }
                    if (slate_1.Editor.node(editor, slate_1.Path.parent(selection.focus.path))[0] === child) {
                        tokens.push(createFocusToken());
                    }
                }
                break;
            case Common_1.InlineType.Variable:
                if (!(0, Utils_1.isLeafInline)(child)) {
                    throw new Error("variable is not actually a leaf Inline. Something is horribly wrong with the tokeniser");
                }
                tokens.push(createVariableToken(child));
                break;
        }
    }
    else if (slate_1.Text.isText(child)) {
        if (selection) {
            var anchorNodeEntry = slate_1.Editor.node(editor, selection.anchor);
            var focusNodeEntry = slate_1.Editor.node(editor, selection.focus);
            if (child === anchorNodeEntry[0] && !selection.anchorAfter) {
                tokens.push(createAnchorToken());
            }
            if (child === focusNodeEntry[0] && !selection.focusAfter) {
                tokens.push(createFocusToken());
            }
        }
        if (!parentIsVoid) {
            var toAdd = createTextTokenFromLeaf(child, attributes, commentTracker);
            if (commentTracker) {
                Object.keys(commentTracker.prevIds).forEach(function (id) {
                    if (!commentTracker.currIds[id]) {
                        tokens.push(createCommentEndToken(id));
                    }
                });
                Object.keys(commentTracker.currIds).forEach(function (id) {
                    if (!commentTracker.prevIds[id]) {
                        tokens.push(createCommentStartToken(id));
                    }
                });
            }
            tokens.push(toAdd);
        }
        if (selection) {
            var anchorNodeEntry = slate_1.Editor.node(editor, selection.anchor);
            var focusNodeEntry = slate_1.Editor.node(editor, selection.focus);
            if (child === anchorNodeEntry[0] && selection.anchorAfter) {
                tokens.push(createAnchorToken());
            }
            if (child === focusNodeEntry[0] && selection.focusAfter) {
                tokens.push(createFocusToken());
            }
        }
    }
    return tokens;
};
var createTextTokenFromLeaf = function (leaf, attributes, commentTracker) {
    if (!slate_1.Text.isText(leaf)) {
        throw new Error("Leaf isnt actually a leaf. Something is horribly wrong with the tokeniser");
    }
    var tokenAttributes;
    if (hasAttributes(attributes)) {
        tokenAttributes = cloneAttributes(attributes);
    }
    else {
        tokenAttributes = {};
    }
    processMarks(leaf.marks, tokenAttributes, commentTracker);
    return createTextToken(leaf.text, tokenAttributes);
};
var processMarks = function (marks, attributes, commentTracker) {
    var e_1, _a;
    if (commentTracker) {
        commentTracker.prevIds = commentTracker.currIds;
        commentTracker.currIds = {};
    }
    if (!marks || marks.length == 0) {
        return;
    }
    try {
        for (var marks_1 = __values(marks), marks_1_1 = marks_1.next(); !marks_1_1.done; marks_1_1 = marks_1.next()) {
            var mark = marks_1_1.value;
            switch (mark.type) {
                case "bold":
                    if (!attributes.style) {
                        attributes.style = {};
                    }
                    attributes.style.bold = true;
                    break;
                case "italic":
                    if (!attributes.style) {
                        attributes.style = {};
                    }
                    attributes.style.italic = true;
                    break;
                case "strikethrough":
                    if (!attributes.style) {
                        attributes.style = {};
                    }
                    attributes.style.strikethrough = true;
                    break;
                case "comment":
                    if (commentTracker) {
                        commentTracker.currIds[mark.data.id] = true;
                    }
                    break;
                default:
                    throw new Error("Unhandled mark type: ".concat(mark.type));
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (marks_1_1 && !marks_1_1.done && (_a = marks_1.return)) _a.call(marks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
var createTextToken = function (text, attributes) {
    return TokenModels_1.default.text.createToken(text, attributes.style, attributes.href);
};
var createAnchorToken = function () {
    return {
        type: "selection",
        subType: "anchor",
    };
};
var createFocusToken = function () {
    return {
        type: "selection",
        subType: "focus",
    };
};
var createBreakToken = function () {
    return {
        type: "inline",
        subType: "lineBreak",
    };
};
var createVariableToken = function (editorNode) {
    var substitutionToken = editorNode.data.substitutionToken;
    var persistedToken = {
        type: "inline",
        subType: editorNode.type,
        isBold: editorNode.data.isBold,
        isItalic: editorNode.data.isItalic,
        isStrikethrough: editorNode.data.isStrikethrough,
        providerType: editorNode.data.providerType,
        label: editorNode.data.variableLabel.trim(),
        name: editorNode.data.variableName.trim(),
    };
    if (substitutionToken) {
        persistedToken.substitutionToken = substitutionToken;
    }
    return persistedToken;
};
var createCommentStartToken = function (id) {
    return {
        type: "comment",
        subType: "start",
        id: id,
    };
};
var createCommentEndToken = function (id) {
    return {
        type: "comment",
        subType: "end",
        id: id,
    };
};
var hasAttributes = function (attributes) {
    return !!(attributes.href != null || attributes.style);
};
var cloneAttributes = function (base) {
    var copy = {};
    if (base.href != null) {
        copy.href = base.href;
    }
    if (base.style) {
        copy.style = {};
        if (base.style.bold != null) {
            copy.style.bold = base.style.bold;
        }
        if (base.style.italic != null) {
            copy.style.italic = base.style.italic;
        }
        if (base.style.strikethrough != null) {
            copy.style.strikethrough = base.style.strikethrough;
        }
    }
    return copy;
};
var shouldMergeTextToken = function (tokens, newTextToken) {
    var lastToken = tokens[tokens.length - 1];
    if (newTextToken.subType !== "text" || !lastToken || lastToken.subType !== "text") {
        return false;
    }
    return (((!lastToken.href && !newTextToken.href) || lastToken.href === newTextToken.href) &&
        ((!lastToken.style && !newTextToken.style) || (0, lodash_1.isEqual)(lastToken.style, newTextToken.style)));
};
var logAnySideBySideColumnIssues = function (sideBySide) {
    [1, 2].forEach(function (columnIndex) {
        var sideBySideColumn = sideBySide.children[columnIndex];
        if (sideBySideColumn.children && sideBySideColumn.children.length > 0) {
            return;
        }
        var nodeMetadata = [];
        var metadataRetrievalWasSuccessful = false;
        try {
            nodeMetadata = (0, DebugEditorState_1.getNodeMetadataFromChildren)(sideBySide.children);
            metadataRetrievalWasSuccessful = true;
        }
        catch (_a) { }
        var payload = {
            columnNodeType: sideBySideColumn.type,
            columnIndex: columnIndex,
            nodeMetadata: nodeMetadata,
            metadataRetrievalWasSuccessful: metadataRetrievalWasSuccessful,
        };
        (0, SerialiseErrorRecorder_1.sendSideBySideColumnIssueToSentry)(payload);
    });
};
var serialiseImage = function (block, editor, commentTracker, selection) {
    var src = block.data.src;
    if (!src && block.data.variable == null && block.data.uploadId) {
        return [];
    }
    var tokens = [];
    if (block.data.variable != null && block.data.variable.name != null) {
        var mediaVariableToken = {
            type: "block",
            subType: Common_1.BlockType.MediaVariable,
            media: "image",
            name: block.data.variable.name,
            label: block.data.variable.label,
        };
        if (block.data.alignment != null) {
            mediaVariableToken.alignment = block.data.alignment;
        }
        if (block.data.alt != null) {
            mediaVariableToken.alt = new Types_1.LiteralInput(block.data.alt);
        }
        if (block.data.role != null) {
            mediaVariableToken.role = block.data.role;
        }
        if (block.data.width != null) {
            mediaVariableToken.width = block.data.width;
        }
        if (block.data.frame != null) {
            mediaVariableToken.frame = block.data.frame;
        }
        if (block.data.variable.substitutionToken) {
            mediaVariableToken.substitutionToken = block.data.variable.substitutionToken;
        }
        tokens.push(mediaVariableToken);
    }
    else {
        var imageToken = {
            type: "block",
            subType: Common_1.BlockType.Image,
            src: src,
        };
        if (block.data.width) {
            imageToken.width = block.data.width;
        }
        if (block.data.href) {
            imageToken.href = block.data.href;
        }
        if (block.data.alt) {
            imageToken.alt = new Types_1.LiteralInput(block.data.alt);
        }
        if (block.data.role) {
            imageToken.role = block.data.role;
        }
        if (block.data.alignment) {
            imageToken.alignment = block.data.alignment;
        }
        if (block.data.frame) {
            imageToken.frame = block.data.frame;
        }
        if (block.data.aspectRatio) {
            imageToken.aspectRatio = block.data.aspectRatio;
        }
        if (block.data.scale) {
            imageToken.scale = block.data.scale;
        }
        if (block.data.translation) {
            imageToken.translation = block.data.translation;
        }
        tokens.push(imageToken);
    }
    return tokens.concat((0, exports.getChildTokens)(block, editor, commentTracker, selection));
};
var getChildTokens = function (block, editor, commentTracker, selection) {
    var tokens = [];
    for (var i = 0; i < block.children.length; i++) {
        var child = block.children[i];
        var createdTokens = serialiseChild(child, {}, block.isVoid, editor, commentTracker, selection);
        tokens = tokens.concat(createdTokens);
    }
    return tokens;
};
exports.getChildTokens = getChildTokens;
var serialiseVideo = function (block, editor, commentTracker, selection) {
    var newTokens = [];
    if (block.data.variable != null && block.data.variable.name != null) {
        var mediaVariableToken = MediaVariable_1.mediaVariable.createToken(MediaVariable_2.Media.Video, block.data.variable.name, block.data.variable.label, {
            width: block.data.width,
        });
        if (block.data.variable.substitutionToken) {
            mediaVariableToken.substitutionToken = block.data.variable.substitutionToken;
        }
        newTokens.push(mediaVariableToken);
    }
    else {
        var videoToken = {
            type: "block",
            subType: Common_1.BlockType.Video,
        };
        if (block.data.displayUrl) {
            videoToken.displayUrl = block.data.displayUrl;
        }
        if (block.data.width) {
            videoToken.width = block.data.width;
        }
        if (block.data.embedUrl) {
            videoToken.embedUrl = block.data.embedUrl;
        }
        newTokens.push(videoToken);
    }
    return newTokens.concat((0, exports.getChildTokens)(block, editor, commentTracker, selection));
};
var serialiseGoogleMaps = function (block, editor, commentTracker, selection) {
    var newTokens = [];
    if (block.data.variable != null && block.data.variable.name != null) {
        var mediaVariableToken = MediaVariable_1.mediaVariable.createToken(MediaVariable_2.Media.GoogleMaps, block.data.variable.name, block.data.variable.label, {
            width: block.data.width,
        });
        if (block.data.variable.substitutionToken) {
            mediaVariableToken.substitutionToken = block.data.variable.substitutionToken;
        }
        newTokens.push(mediaVariableToken);
    }
    else {
        var googleMapsToken = {
            type: "block",
            subType: Common_1.BlockType.GoogleMaps,
        };
        if (block.data.displayUrl) {
            googleMapsToken.displayUrl = block.data.displayUrl;
        }
        if (block.data.width) {
            googleMapsToken.width = block.data.width;
        }
        if (block.data.embedUrl) {
            googleMapsToken.embedUrl = block.data.embedUrl;
        }
        newTokens.push(googleMapsToken);
    }
    return newTokens.concat((0, exports.getChildTokens)(block, editor, commentTracker, selection));
};
var serialiseIframe = function (block, editor, commentTracker, selection) {
    var _a;
    var newTokens = [];
    if (((_a = block.data.variable) === null || _a === void 0 ? void 0 : _a.name) != null) {
        var mediaVariableToken = MediaVariable_1.mediaVariable.createToken(MediaVariable_2.Media.Iframe, block.data.variable.name, block.data.variable.label, {
            width: block.data.width,
            height: block.data.height,
        });
        if (block.data.variable.substitutionToken) {
            mediaVariableToken.substitutionToken = block.data.variable.substitutionToken;
        }
        newTokens.push(mediaVariableToken);
    }
    else {
        var iframeToken = {
            type: "block",
            subType: Common_1.BlockType.Iframe,
        };
        if (block.data.width) {
            iframeToken.width = block.data.width;
        }
        if (block.data.height) {
            iframeToken.height = block.data.height;
        }
        if (block.data.embedUrl) {
            iframeToken.embedUrl = block.data.embedUrl;
        }
        if (block.data.embedPreset) {
            iframeToken.embedPreset = block.data.embedPreset;
        }
        if (block.data.alignment) {
            iframeToken.alignment = block.data.alignment;
        }
        newTokens.push(iframeToken);
    }
    return newTokens.concat((0, exports.getChildTokens)(block, editor, commentTracker, selection));
};
var serialiseROICalculator = function (block, editor, commentTracker, selection) {
    var newTokens = [];
    var roiCalculatorToken = {
        type: "block",
        subType: Common_1.BlockType.ROICalculator,
    };
    roiCalculatorToken.slider = (0, lodash_1.cloneDeep)(block.data.slider);
    roiCalculatorToken.inputs = (0, lodash_1.cloneDeep)(block.data.inputs);
    roiCalculatorToken.roiResult = (0, lodash_1.cloneDeep)(block.data.roiResult);
    roiCalculatorToken.title = (0, lodash_1.cloneDeep)(block.data.title);
    roiCalculatorToken.description = (0, lodash_1.cloneDeep)(block.data.description);
    roiCalculatorToken.variableCounter = block.data.variableCounter;
    roiCalculatorToken.backgroundImageUrl = block.data.backgroundImageUrl;
    roiCalculatorToken.hasSelectedPreset = block.data.hasSelectedPreset;
    newTokens.push(roiCalculatorToken);
    return newTokens.concat((0, exports.getChildTokens)(block, editor, commentTracker, selection));
};
var serialiseAccordion = function (newToken, block, editor, commentTracker, selection) {
    var children = block.children;
    newToken.heading = (0, exports.serialiseElements)(children[1].children, editor, commentTracker, selection);
    newToken.body = (0, exports.serialiseElements)(children[2].children, editor, commentTracker, selection);
    newToken.backgroundImageUrl = block.data.backgroundImageUrl;
    var accordionTokens = [newToken];
    if (selection) {
        var dummyTextNode = children[0].children[0];
        var anchorNodeEntry = slate_1.Editor.node(editor, selection.anchor);
        var focusNodeEntry = slate_1.Editor.node(editor, selection.focus);
        if (dummyTextNode === anchorNodeEntry[0]) {
            accordionTokens.push(createAnchorToken());
        }
        if (dummyTextNode === focusNodeEntry[0]) {
            accordionTokens.push(createFocusToken());
        }
    }
    return accordionTokens;
};
var serialiseSideBySide = function (block, editor, commentTracker, selection) {
    var newToken = {
        type: "block",
        subType: Common_1.BlockType.SideBySide,
        width: block.data.width || SideBySide_1.SideBySideWidth.Normal,
        percent: block.data.percent || 50,
        alignment: block.data.alignment || SideBySide_1.SideBySideAlignment.Normal,
        selection: block.data.selection || null,
        selectedColumns: block.data.selectedColumns || [],
        placeholderIndex: block.data.placeholderIndex || null,
    };
    var children = block.children;
    try {
        logAnySideBySideColumnIssues(block);
    }
    catch (_a) { }
    newToken.column1 = mergeText((0, exports.serialiseElements)(children[1].children, editor, commentTracker, selection));
    newToken.column2 = mergeText((0, exports.serialiseElements)(children[2].children, editor, commentTracker, selection));
    var sideBySideTokens = [newToken];
    if (selection) {
        var dummyTextNode = children[0].children[0];
        var anchorNodeEntry = slate_1.Editor.node(editor, selection.anchor);
        var focusNodeEntry = slate_1.Editor.node(editor, selection.focus);
        if (dummyTextNode === anchorNodeEntry[0]) {
            sideBySideTokens.push(createAnchorToken());
        }
        if (dummyTextNode === focusNodeEntry[0]) {
            sideBySideTokens.push(createFocusToken());
        }
    }
    return sideBySideTokens;
};
var mergeText = function (tokens) {
    return tokens.reduce(function (processedTokens, currToken) {
        if (shouldMergeTextToken(processedTokens, currToken)) {
            var lastToken = processedTokens[processedTokens.length - 1];
            lastToken.content += currToken.content;
        }
        else {
            processedTokens.push(currToken);
        }
        return processedTokens;
    }, []);
};
